<template>
  <div class="flex number-input">
    <button class="subtract" @click="decrement">
      <!-- <span class="icon-substract"></span> -->
    </button>
    <span>{{localValue}}</span>
    <!-- <input placeholder="1" min="1" v-model="localValue" /> -->
    <button class="add" @click="increment">
      <!-- <span class="icon-add"></span> -->
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: Number
  },

  data () {
    return {
      localValue: this.value
    }
  },

  watch: {
    value (newValue) {
      this.localValue = newValue
    },

    localValue (newValue) {
      this.$emit('input', newValue)
    }
  },

  methods: {
    increment () {
      ++this.localValue
    },

    decrement () {
      --this.localValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/NumberInput.vue